// extracted by mini-css-extract-plugin
export default {"feed":"index_feed_rnXbq","feedTitle":"index_feedTitle_3IQOu","feedBref":"index_feedBref_PDaLo","feedImg":"index_feedImg_P-QUv"};